import { Link } from "react-router-dom";
import { categories, siteInfo } from "@/mocks/manga";

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 font-comic text-lg text-background-50">
                漫
              </span>
              <span className="font-comic text-xl font-bold text-foreground-950">43423漫画网</span>
            </Link>
            <p className="mt-4 text-xs leading-relaxed text-foreground-600">
              {siteInfo.slogan}。专注提供《健身教练》等优质中文漫画的免费在线阅读服务，海量作品、高清画质、每日更新，随时随地畅享漫画乐趣。
            </p>
            <div className="mt-4 flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-background-200 text-foreground-700">
                <i className="ri-wechat-line text-sm"></i>
              </span>
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-background-200 text-foreground-700">
                <i className="ri-qq-line text-sm"></i>
              </span>
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-background-200 text-foreground-700">
                <i className="ri-weibo-line text-sm"></i>
              </span>
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-background-200 text-foreground-700">
                <i className="ri-bilibili-line text-sm"></i>
              </span>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-black text-foreground-950">热门分类</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {categories.slice(1).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.id}`}
                    className="flex items-center gap-1.5 text-xs text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    <i className="ri-arrow-right-s-line text-primary-400"></i>
                    {cat.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-black text-foreground-950">阅读导航</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              <li>
                <Link to="/" className="flex items-center gap-1.5 text-xs text-foreground-600 transition-colors hover:text-primary-600">
                  <i className="ri-arrow-right-s-line text-primary-400"></i>
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="flex items-center gap-1.5 text-xs text-foreground-600 transition-colors hover:text-primary-600">
                  <i className="ri-arrow-right-s-line text-primary-400"></i>
                  漫画大全
                </Link>
              </li>
              <li>
                <Link to="/manga/fitness-coach" className="flex items-center gap-1.5 text-xs text-foreground-600 transition-colors hover:text-primary-600">
                  <i className="ri-arrow-right-s-line text-primary-400"></i>
                  《健身教练》漫画
                </Link>
              </li>
              <li>
                <Link to="/#ranking" className="flex items-center gap-1.5 text-xs text-foreground-600 transition-colors hover:text-primary-600">
                  <i className="ri-arrow-right-s-line text-primary-400"></i>
                  人气榜单
                </Link>
              </li>
              <li>
                <Link to="/about" className="flex items-center gap-1.5 text-xs text-foreground-600 transition-colors hover:text-primary-600">
                  <i className="ri-arrow-right-s-line text-primary-400"></i>
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-black text-foreground-950">联系我们</h3>
            <ul className="mt-4 flex flex-col gap-2.5 text-xs text-foreground-600">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-sm text-primary-500"></i>
                {siteInfo.email}
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line mt-0.5 text-sm text-primary-500"></i>
                {siteInfo.phone}
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-2-line mt-0.5 text-sm text-primary-500"></i>
                {siteInfo.address}
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-sm text-primary-500"></i>
                {siteInfo.workHours}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-background-200 pt-6">
          <p className="text-[11px] leading-relaxed text-foreground-500">
            免责声明：本站漫画内容均来源于网络公开渠道搜集整理，仅供读者学习交流与试读参考，版权归原作者及出版社所有。请于阅读后24小时内删除，支持正版请购买原版漫画。
          </p>
          <div className="mt-4 flex flex-col items-center justify-between gap-3 text-[11px] text-foreground-500 sm:flex-row">
            <p>© 2020-2026 {siteInfo.name} 版权所有 · {siteInfo.icp}</p>
            <p className="flex items-center gap-1">
              <i className="ri-shield-check-line text-accent-600"></i>
              内容安全 · 绿色阅读
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}